export default "__VITE_ASSET__uqtgAE$b__";